import { RouteBase } from "./route-base.model";

export class LclRoute extends RouteBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    protected comment: string,
    public chargeableWeightPrice?: number,
    public blPrice?: number,
  ) {
    super(id, discriminator, comment);
  }

  public getChargeableWeightPrice(): number {
    return this.chargeableWeightPrice;
  }
  public setChargeableWeightPrice(param: number) {
    this.chargeableWeightPrice = param;
  }

  public getBlPrice(): number {
    return this.blPrice || 0;
  }
  public setBlPrice(param: number) {
    this.blPrice = param;
  }
}
